import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

function resolveDestAfterLogin(role) {
  if (role === "admin") return "/admin";
  if (role === "vendor") return "/vendor";
  return "/dashboard";
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) { toast.error(res.error); return; }
    toast.success(`Welcome back, ${res.user.name}`);
    const dest = loc.state?.from?.pathname || resolveDestAfterLogin(res.user.role);
    nav(dest, { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#050B14] text-white">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="bg-[#0A111A]/60 backdrop-blur-2xl border border-white/10 rounded-2xl p-8 shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-3">Welcome back</p>
          <h1 className="text-3xl font-light tracking-tight mb-8">Sign in.</h1>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-slate-300 text-xs uppercase tracking-wider">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="bg-[#050B14] border-white/10 text-white mt-2 focus:border-sky-400 focus:ring-1 focus:ring-sky-400" />
            </div>
            <div>
              <Label htmlFor="pw" className="text-slate-300 text-xs uppercase tracking-wider">Password</Label>
              <Input id="pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="bg-[#050B14] border-white/10 text-white mt-2 focus:border-sky-400 focus:ring-1 focus:ring-sky-400" />
            </div>
            <Button type="submit" disabled={busy} data-testid="login-submit-btn"
              className="w-full bg-sky-400 text-[#050B14] hover:bg-sky-300 font-medium py-6">
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <p className="text-sm text-slate-400 mt-6 text-center">
            New to RideKaroo? <Link to="/register" data-testid="login-go-register" className="text-sky-300 hover:text-sky-200">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
